import React, { Component } from 'react'
import { Navbar, Nav, NavDropdown, } from 'react-bootstrap'
import categories from '../../assets/categories'
import logo from '../../assets/logo.png'

class Navigation extends Component {

  constructor(props) {
    super(props)

    this.state = {
      categories: categories
    }

    this.categories = this.categories.bind(this)
  }

  categories() {
    return Object.keys(this.state.categories).map(cat => (
      <NavDropdown 
          title={cat.toUpperCase()} 
          className="basic-nav-dropdown"
          key={cat}>
          {Object.keys(this.state.categories[cat]).map((subCat) => (
              <NavDropdown.Item key={subCat} href={this.state.categories[cat][subCat].url}>{subCat.toUpperCase()}</NavDropdown.Item>
            )
          )}
        </NavDropdown>
      )
    )
  }

  render() {
    return (
      <Navbar className="navBar" expand="xl">
        <Navbar.Brand href="/">
          <img src={logo} className="navLogo" alt="ATC Gardening logo" />
        </Navbar.Brand>
        <div className="toggleWrapper">
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <p className="navBarLabel">MENU</p>
        </div>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
            {this.categories()}
            <Nav.Link href="/contact">CONTACT</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    )
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation.jsx